import { SET_COOKIE_GROUPS, SET_COOKIE_ACK } from 'framework/vuex/mutation-types';


export default {
    /**
     * Set a group of allowed cookies
     *
     * @param {object} state
     * @param {string[]} groups
     */
    [SET_COOKIE_GROUPS](state, { groups }) {
        state.allowedGroups = groups;
    },

    /**
     * Set acknowledge
     * @param {ICookieStore} state
     * @param {boolean} ack
     */
    [SET_COOKIE_ACK](state, { ack }) {
        state.cookieAck = ack;
    },
};
